module.exports = __webpack_public_path__ + "static/media/22.5f1dc4c9.jpg";